import { useState } from "react";
import Datatable from "../../../../components/Datatable/Datatable";
import peticionBack from "../../../../libs/peticiones/peticionBack";
import { toaster } from "rsuite";
import createURL from "../../../../libs/peticiones/url";
import { Report } from "../../../../enums/Report";

export default function Usuarios({ report, openT }: { report: any ,openT: boolean }) {
    const [refresh, setRefresh] = useState<boolean>(false);

    async function getData(order: string, records: number, page: number, search: string) {
        const url = createURL(`/reportes/${Report.USER}`, [
            { name: "order", value: order },
            { name: "records", value: records },
            { name: "page", value: page },
            { name: "search", value: search },
            { name: "rows", value: "_id,fullname,email,phone" },
        ]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        return res;
    }

    /* TABLA */
    const columns = [
        { data: "fullname" },
        { data: "email", render: (d: string) => <a href={`mailto:${d}`} type="e">{d}</a> },
        { data: "phone", render: (d: string) => <a href={`tel:${d}p000`} type="e">{d}</a> },
    ];

    const columnDefs = [
        { className: "text-center", targets: [0, 1, 2] },
    ];

    return (
        <>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4 className="">Usuarios</h4>
            </div>
            <Datatable
                columns={columns}
                headers={["Nombre", "Correoe Electrónico", "Teléfono"]}
                columnDefs={columnDefs}
                petition={getData}
                control="back"
                stateRefresh={[refresh, setRefresh]}
                className="p-0"
            />
        </>
    );
}
